import {qs} from '@shared/helpers/queryString'
import {SchemasUniversalDelivery} from '@shared/schemas/universal'

import {ZipcodeSearch} from '@web/core/constants'
import getApi, {createWrapper, getCommonBaseUrl} from '@web/helpers/api'

const api = getApi(getCommonBaseUrl())

const ErrorMessageMap: Record<string, string> = {
    XE8100: '두 글자 이상의 주소명을 입력해주세요',
}

const DeliveryManagerApiUrlInfo = {
    zipCode: '/delivery/zipCode',
    revealedZipCode: '/delivery/zipCode/public',
}

/** 우편번호 검색 */
const searchZipCode = async ({
    keyword,
    limit = ZipcodeSearch.LIST_MAX_LENGTH_PER_PAGE,
    offset,
    regionCode,
    allowSixDigit = false,
    showRegionCount = true,
    revealed = false,
}: {
    keyword: string
    limit?: number
    offset?: number
    regionCode?: string
    allowSixDigit?: boolean
    showRegionCount?: boolean
    revealed?: boolean
}) => {
    const result = await createWrapper<SchemasUniversalDelivery['/delivery/zipCode']['response']>(
        api.get(
            qs.stringifyUrl({
                url: revealed ? DeliveryManagerApiUrlInfo.revealedZipCode : DeliveryManagerApiUrlInfo.zipCode,
                query: {
                    keyword,
                    limit,
                    regionCode,
                    allowSixDigit,
                    showRegionCount,
                    offset,
                },
            }),
        ),
    )

    if (result.errorCode) {
        throw new Error(ErrorMessageMap[result.errorCode] ?? '일시적인 오류입니다. 다시 시도해주세요')
    }

    return result
}

export default {searchZipCode}
